import React, { Component } from 'react';
import {connect} from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';

import { addIssueByCommunity, updIssue } from '../../actions/issueAction';


import { Button, Card, CardActions, CardContent, Checkbox, Grid, Paper } from '@material-ui/core';
import { renderLegacyImage, renderLegacyTextField, renderSwitchWithLabelV4 } from '../../utils/engageComponents';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';
import { sweetAlert } from '../../components/Alert/sweetAlert';

const validate = (values, props) => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Please enter a Name';
    } else if (values.name.length > props.characterLimit) {
        errors.name = `The item must have less than ${props.characterLimit} characters`;
    }

    if (!values.iconUrl) {
        errors.iconUrl = 'Please select an icon';
    }
    return errors;
};

class AddEditIssue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            action: props.data && props.data._id ? 'edit' : 'new',
            _id: props?.data?.id?props.data._id:null,
            items : props.items,
            itemsByIssue: props?.data?.items ? [...this.props.data.items]: [],
            waterDamage:false,
            residentDiscomfort:false,
            SweetAlertStyles: {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'},
        };

        if (props.data) {
            this.props.dispatch(change('IssueForm', '_id', props.data && props.data._id));
            this.props.dispatch(change('IssueForm', 'name', props.data && props.data.name));
        } else {
            this.props.dispatch(change('IssueForm', '_id', ''));
            this.props.dispatch(change('IssueForm', 'name', ''));
        }
    }

    componentDidMount(){
        if(this.props.data){
            this.setState({
                waterDamage:this.props.data.waterDamage,
                residentDiscomfort:this.props.data.residentDiscomfort,
                _id:this.props.data._id
            })
        }
    }

    handleToggle = (value) => {
        if (!this.state.itemsByIssue) {
            const newChecked = [];
            newChecked.push(value);

            this.setState({ itemsByIssue: newChecked })
        } else {
            const currentIndex = this.state.itemsByIssue.indexOf(value);
            const newChecked = this.state.itemsByIssue;

            if (currentIndex === -1) {
                newChecked.push(value);
            } else {
                newChecked.splice(currentIndex, 1);
            }

            this.setState({ itemsByIssue: newChecked })
        }

        this.isSwitchChecked();
    };


    handleChange = (event) => {
        //setState({ ...state, [event.target.name]: event.target.checked });
        if (event.target.checked)
            this.setState({ itemsByIssue: (this.props && this.props.items && this.props.items.length > 0) ? this.props.items.map(item => item._id) : [] })
        else
            this.setState({ itemsByIssue: [] })
    };



    isSwitchChecked = () => {
        let isChecked = false;

        if (this.props.items && Array.isArray(this.props.items) && (typeof (this.state.itemsByIssue) === 'object') && this.state.itemsByIssue) {
            isChecked = !this.props.items.some((i) => this.state.itemsByIssue.indexOf(i._id) === -1);
        }

        return isChecked;
    }

    onSubmitHandler=(formData)=>{

        formData.items = this.state.itemsByIssue

        if (formData.name.length > this.props.characterLimit) {
            const message = `The issue must have less than ${this.props.characterLimit} characters`
            sweetAlert('error', message, 'alert_AddEditItem_CharacterLimit_Error');
            return;
        }

        formData.waterDamage = this.state.waterDamage;
        formData.residentDiscomfort = this.state.residentDiscomfort;


        if (!this.state._id) {
            this.props.addIssueByCommunity(formData, localStorage.getItem('communityId'), this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});

        } else {
            this.props.updIssue(this.state._id, formData, this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});

        }

        this.setState({ itemsByIssue: [] })

        this.props.close();
    }



    render() {
        const { handleSubmit } = this.props;

        return (
            <>
                <Paper elevation={3} square='false' color='secondary'>
                    <Grid id='add_item_modal' className="LItemspaperModal">
                        <form style={{height:'100%'}}>
                            <Grid item container xs={12} style={{height:'90%'}} alignItems='baseline'>
                                <Grid item xs={12} className='lmodalTitle'>{this.props.data? 'Update Issue': 'New Issue'}</Grid>

                                <Grid item container xs={12} className='LformSection' alignItems='center' style={{padding:'20px'}}>
                                    <Grid item container xs={12} md={8} lg={6}>
                                        <Field
                                            id='rooms_add_room_name'
                                            name="name"
                                            label="Name"
                                            maxLength={20}
                                            component={renderLegacyTextField}
                                            inputLabelClass='ldefaultTextStyles'
                                            inputClass='ldefaultTextStyles'
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}  md={8} lg={6}></Grid>


                                    <Grid item xs={12} sm={6} style={{marginTop:'1rem'}}>
                                        <Field
                                            labelInLeft={true}
                                            name="waterDamage"
                                            label="Water damage risk"
                                            checked={this.state.waterDamage}
                                            onClick={ () => {
                                                
                                                if(this.state.residentDiscomfort){
                                                    sweetAlert('error','You can add just one indicator per issue')
                                                }else{
                                                    this.setState((prevState) => ({waterDamage: !prevState.waterDamage   }))
                                                }                            
                                            }}
                                            component={renderSwitchWithLabelV4}
                                            idToSet='water_damage_switch'
                                            stylesLabel={{fontSize:'18px', fontFamily:'Gotham-Bold', color:'black'}}

                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} style={{marginTop:'1rem'}}>
                                        <Field
                                            labelInLeft={true}
                                            name="residentDiscomfort"
                                            label="Resident discomfort risk"
                                            checked={this.state.residentDiscomfort}
                                            onClick={ () =>{ 
                                                if(this.state.waterDamage){
                                                    sweetAlert('error','You can add just one indicator per issue')
                                                }else{
                                                    this.setState((prevState) => ({residentDiscomfort: !prevState.residentDiscomfort   }))
                                                }
                                            }}
                                            component={renderSwitchWithLabelV4}
                                            idToSet='resident_discomfort_switch'
                                            stylesLabel={{fontSize:'18px', fontFamily:'Gotham-Bold', color:'black'}}

                                        />
                                    </Grid>
                                   
                                </Grid>

                                {/* List of Items */}
                                <Grid item container xs={12} className='LformSection itemslistcontainer'>
                                    <Grid item xs={12}>
                                        <p className='ldefaultTextStyles' style={{fontSize:'20px', textAlign:'center', marginBottom:'10px'}}>Items list</p>
                                        <div style={{ textAlign: 'left' }}>
                                            <Grid item xs={6} md={4} lg={2} style={{ padding: '10px', paddingTop: '40px' }}>
                                                <Field
                                                    name="selectAll"
                                                    label="Select All"
                                                    checked={this.isSwitchChecked()}
                                                    onClick={this.handleChange}
                                                    component={renderSwitchWithLabelV4}
                                                    stylesLabel={{fontSize:'18px', fontFamily:'Gotham-Book', color:'black'}}
                                                    idToSet='selectAlltoogle'
                                                    id='selectAlltoogle'
                                                />
                                            </Grid>
                                        </div>
                                    </Grid>
                                    
                                    <Grid item container>
                                        {
                                            this.props.items && Array.isArray(this.props.items) && this.props.items.map((item, index) => {

                                                return (

                                                    <Grid item xs={6} sm={6} md={4} lg={3} style={{ padding: '4px' }} key={item._id}>
                                                        <Card key={index} className="lcardElement" id={`items_room_card_${item._id}`} >
                                                            <CardContent className="diningMenuSize card-center-container">
                                                                {
                                                                    renderLegacyImage(item)
                                                                }
                                                            </CardContent>
                                                            <CardActions>
                                                                <Grid item container xs={12} alignContent='center' style={{ height: '100%', overflow: 'hidden' }}>
                                                                    <Grid item container xs={4} md={3} lg={2}  justifyContent='center' alignContent='center' className='CheckboxBlue RepairsCell'>
                                                                        <Checkbox
                                                                            id={`checkbox_${item._id}`}
                                                                            checked={this.state.itemsByIssue ? this.state.itemsByIssue.indexOf(item._id) !== -1 : false}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                            onChange={() => this.handleToggle(item._id)}
                                                                            icon={<CheckBoxOutlineBlank fontSize="large" style={{color:'black'}} />}
                                                                            checkedIcon={
                                                                                <CheckBox fontSize="large"  style={{color:'#009EDD'}} />
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                    <Grid item container xs={8} md={9} lg={10} alignContent='center' className='WrapText lengage_Title' style={{ overflow: 'hidden' }}>
                                                                        {
                                                                            item.name
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                            </CardActions>
                                                        </Card>
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                
                                </Grid>
                               

                            </Grid>

                              {/* Buttons section */}
                            <Grid item container justifyContent='space-evenly' xs={12} alignItems='center' style={{height:'10%'}}>
                                <Button id='cancel_btn' item container className="lcancelBtn" onClick={()=>this.props.close()}>
                                    Cancel
                                </Button>
                 
                                <Button id='save_btn' item container className="Lsetup_btn" onClick={handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Save
                                </Button>

                            </Grid>
                        </form>


                    
                    </Grid>
               
                </Paper>

            </>
        )
    }
}

function mapStateToProps(state,dispatch) {
    const items = state.itemReducer && state.itemReducer.itemData && Array.isArray(state.itemReducer.itemData) ? state.itemReducer.itemData : [];

    return{
        items
    }
};

export default connect(mapStateToProps, {addIssueByCommunity, updIssue})(reduxForm({
    form: 'IssueForm',
    validate,
    enableReinitialize: true,
})(AddEditIssue));

